import { render, staticRenderFns } from "./KpiWorkbench.vue?vue&type=template&id=86f76d2e"
import script from "./KpiWorkbench.vue?vue&type=script&lang=js"
export * from "./KpiWorkbench.vue?vue&type=script&lang=js"
import style0 from "./KpiWorkbench.vue?vue&type=style&index=0&id=86f76d2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports